import { useCallback } from "react"
import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { useIsLeaveSupplierProcessAgreement } from "./useIsLeaveSupplierProcessAgreement"

const graphQLFragments = {
    agreement: graphql(
        `
            fragment useIsAgreementTerminable_Agreement on AgreementType {
                isActive
                supplyPoint {
                    marketName
                }
                ...useIsLeaveSupplierProcessAgreement_Agreement
            }
        `,
        [useIsLeaveSupplierProcessAgreement.fragments.agreement]
    ),
}

type UseIsAgreementTerminableProps = {
    accountNumber: string
}

type IsAgreementTerminableProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function useIsAgreementTerminable({ accountNumber }: UseIsAgreementTerminableProps) {
    const isLeaveSupplierProcessAgreement = useIsLeaveSupplierProcessAgreement({ accountNumber })

    return useCallback(
        (props: IsAgreementTerminableProps) => {
            const agreement = readFragment(graphQLFragments.agreement, props.agreement)

            return !isLeaveSupplierProcessAgreement({ agreement }) && agreement.isActive
        },
        [isLeaveSupplierProcessAgreement]
    )
}

useIsAgreementTerminable.fragments = graphQLFragments
